(() => {
  'use strict';
  const button = document.querySelector('[data-xerf-play]');
  const video = document.querySelector('[data-xerf-video]');
  if (!button || !video) return;
  const status = document.querySelector('[data-xerf-status]');
  const es = document.documentElement.lang === 'es';
  button.hidden = false;
  const failed = () => {
    delete video.dataset.loaded;
    status.textContent = es ? 'No se pudo reproducir el video. Puedes abrir el archivo o leer la descripción debajo.' : 'The video could not play. Open the file or read the description below.';
    button.hidden = false;
  };
  video.addEventListener('error', failed);
  video.addEventListener('play', () => {
    video.dataset.loaded = 'true';
    button.hidden = true;
    status.textContent = '';
  });
  button.addEventListener('click', async () => {
    status.textContent = '';
    if (!video.dataset.loaded) {
      video.src = video.dataset.src;
      video.dataset.loaded = 'true';
      video.load();
    }
    button.hidden = true;
    video.focus({preventScroll:true});
    try { await video.play(); } catch (_) { failed(); }
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
})();
